import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['parentField']

  connect() {
    const positionId = parseInt(this.data.get('position-id'), 10)
    if (positionId) this.fetchAndShow(positionId)
  }

  positionChanged(event) {
    const positionId = parseInt(event.target.value, 10)
    if (!positionId) { this.hideParentField(); return }
    this.updateCombobox({ value: null })
    this.fetchAndShow(positionId)
  }

  fetchAndShow(positionId) {
    fetch(`/organigram_positions/${positionId}/parent_users`)
      .then(r => r.json())
      .then(users => users.length ? this.showParentField(users) : this.hideParentField())
  }

  hideParentField() {
    this.parentFieldTarget.classList.add('d-none')
    this.updateCombobox({ required: false })
  }

  showParentField(users) {
    const comboDiv = this.parentFieldTarget.querySelector('[data-react-class]')
    const existingValue = comboDiv ? JSON.parse(comboDiv.dataset.reactProps).value : null
    this.updateCombobox({ options: users, value: existingValue, required: true })
    this.parentFieldTarget.classList.remove('d-none')
  }

  updateCombobox(propsUpdate) {
    const comboDiv = this.parentFieldTarget.querySelector('[data-react-class]')
    if (!comboDiv) return
    if (window.ReactRailsUJS) window.ReactRailsUJS.unmountComponents(this.parentFieldTarget)
    const props = JSON.parse(comboDiv.dataset.reactProps)
    Object.assign(props, propsUpdate)
    comboDiv.dataset.reactProps = JSON.stringify(props)
    if (window.ReactRailsUJS) window.ReactRailsUJS.mountComponents(this.parentFieldTarget)
  }
}
